export default "__VITE_ASSET__BoD_a2Um__"